// @flow
import React from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import { buttonStyles } from "../../styles/buttonStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  fullWidth: {
    width: "100%"
  },
  autoWidth: {
    width: "auto"
  }
});

type SubmitButtonClassesType = {
  ...ButtonStylesClassesType,
  fullWidth: DictionaryType,
  autoWidth: DictionaryType
};

type SubmitButtonPropsType = {
  classes: SubmitButtonClassesType,
  loading?: boolean,
  disabled?: boolean,
  title?: string,
  fullWidth?: boolean,
  isMainButton?: boolean,
  id?: string,
  onClick?: Function
};

const SubmitButton = (props: SubmitButtonPropsType): React$Element<*> => {
  const classes = props.classes;
  if (props.loading) {
    return (
      <Button
        type={props.onClick ? "button" : "submit"}
        variant="contained"
        color="default"
        id={props.id ? props.id : "submitBtn"}
        className={classNames(
          classes.disabledBtn,
          props.fullWidth && classes.fullWidth,
          !props.fullWidth && classes.autoWidth
        )}
        disabled={true}
      >
        <CircularProgress
          size={14}
          color="inherit"
          style={{ marginRight: "5px" }}
        />
        Sending
      </Button>
    );
  } else {
    return (
      <Button
        type={props.onClick ? "button" : "submit"}
        variant="contained"
        color="primary"
        id={props.id ? props.id : "submitBtn"}
        className={classNames(
          props.isMainButton && classes.primaryBtn,
          !props.isMainButton && classes.darkBtn,
          props.fullWidth && classes.fullWidth,
          !props.fullWidth && classes.autoWidth
        )}
        disabled={props.disabled ? true : false}
        {...(props.onClick ? { onClick: props.onClick } : {})}
      >
        {props.title ? props.title : "Submit"}
      </Button>
    );
  }
};

export default withStyles(styles)(SubmitButton);
